import InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import getSkypeApi from '../chatManager/getSkypeApi';
import SkypePresence from '../store/schema/SkypePresence';
import signInIM from '../chatManager/signInIM';
import updateSelfPresence from '../../presenceManager/updateSelfPresence';
import { clearPresenceCallbacks } from './subscribePresence';
import setShouldAutoSignIn from '../services/setShouldAutoSignIn';

export default function dispatchPresenceUpdateFromHeader(
    currentPresence: InstantMessagePresenceType,
    newPresence: InstantMessagePresenceType
) {
    if (newPresence == 'Offline') {
        getSkypeApi().then(api => {
            api.me.resetStatus();
            api.signOut(() => {
                updateSelfPresence('Offline');
                clearPresenceCallbacks();
                setShouldAutoSignIn(false /*shouldAutoSignIn*/);
            });
        });
    } else if (currentPresence == 'Offline') {
        signInIM(true /*isUserExplicitSignIn*/);
    } else {
        getSkypeApi().then(api => {
            api.me.status(convertToSkypePresence(newPresence));
        });
    }
}

function convertToSkypePresence(presence: InstantMessagePresenceType): SkypePresence {
    switch (presence) {
        case 'Online':
        case 'IdleOnline':
            return 'Online';
        case 'Offline':
        case 'None':
            return 'Offline';
        case 'BeRightBack':
            return 'BeRightBack';
        case 'Away':
            return 'Away';
        case 'Busy':
        case 'IdleBusy':
            return 'Busy';
        case 'DoNotDisturb':
            return 'DoNotDisturb';
    }
}
